import React from "react";

import { Dimmer } from "semantic-ui-react";
import WeezAnimation from "../images/weez-logo.gif";

class Loading extends React.Component {
	render() {
		return (
			<Dimmer active inverted style={{ height: "100vh" }}>
				<img
					alt="Loading Weezevent"
					style={{ maxWidth: "100px" }}
					src={WeezAnimation}
				/>
			</Dimmer>
		);
	}
}

export default Loading;
